import React from 'react';
import '../styles/WorkAreaCard.css';

interface WorkAreaCardProps {
  icon: string;
  title: string;
  description: string;
  items?: string[];
}

const WorkAreaCard: React.FC<WorkAreaCardProps> = ({ icon, title, description, items }) => {
  return (
    <div className="work-area-card">
      <div className="work-area-icon" aria-hidden="true">{icon}</div>
      <h3>{title}</h3>
      <p>{description}</p>
      {items && items.length > 0 && (
        <>
          <h4>Our work includes:</h4>
          <ul>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default WorkAreaCard;
